module.exports = __webpack_public_path__ + "img/speaker.32d8e066.png";